import classNames from "classnames";
import { truncatedBookmarkName } from "@/react/components/Spaces/Bookmarks/helpers/bookmark_helper";
import { TruncateText } from "@circle-react/components/shared/uikit/TruncateText";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import type { Space } from "@circle-react/types";
import { LinkBookmarkIcon } from "./LinkBookmarkIcon";

export interface LinkBookmarkViewProps {
  bookmark?: any;
  className?: string;
  isInsideFolder?: boolean;
  onDeleteClick?: () => void;
  onEditClick?: () => void;
  space?: Space;
}

export const LinkBookmarkView = ({
  space,
  bookmark,
  isInsideFolder,
  onEditClick,
  onDeleteClick,
  className,
}: LinkBookmarkViewProps) => {
  if (!bookmark || !space) {
    return null;
  }

  return (
    <div
      className={classNames(
        "group flex cursor-pointer select-none items-center whitespace-nowrap px-1.5 py-[0.438rem] pr-2.5",
        className,
      )}
    >
      <a
        href={bookmark.url}
        className={classNames(
          "text-default hover:text-dark flex w-full items-center gap-1.5 text-sm",
          {
            "block w-full py-[0.438rem] pl-4 pr-3": isInsideFolder,
          },
        )}
        target="_blank"
        rel="noopener noreferrer"
        draggable="false"
      >
        <LinkBookmarkIcon
          space={space}
          bookmark={bookmark}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
        />
        {isInsideFolder ? (
          <TruncateText
            className={classNames({
              "max-w-[7rem]": !isInsideFolder,
            })}
          >
            <Typography.LabelSm truncate weight="medium">
              {bookmark?.name}
            </Typography.LabelSm>
          </TruncateText>
        ) : (
          <Typography.LabelSm weight="medium">
            {truncatedBookmarkName(bookmark, isInsideFolder ? 13 : 22)}
          </Typography.LabelSm>
        )}
      </a>
    </div>
  );
};
